import { styled } from '@mui/material';

import {
  Box,
  Button,
  ButtonsContainer,
  Modal,
  Typography,
  useModalContext,
} from '@app-velocity/ui';

import { useI18n } from '@app-velocity/i18n';
import { CrownIcon } from '@app-velocity/icons';

import { SubscriptionButton } from '../../../components/SubscriptionButton';

const StyledDescription = styled(Box)({
  textAlign: 'center',
});

const StyledTitle = styled(Typography)(({ theme }) => ({
  fontSize: 18,
  marginBottom: theme.spacing(2),
  textAlign: 'center',
}));

const StyledText = styled(Typography)({
  color: 'var(--text-text-secondary-color)',
  whiteSpace: 'pre-line',
});

const IconContainer = styled('div')({
  textAlign: 'center',
  svg: {
    stroke: 'var(--button-button-primary-color)',
  },
});

export const HigherTierOnlyFeatureModalContent = () => {
  const { t } = useI18n();
  const { closeModal } = useModalContext();

  return (
    <Modal data-testid="pro-feature-modal">
      <Modal.Content>
        <IconContainer>
          <CrownIcon />
        </IconContainer>
        <StyledDescription>
          <StyledTitle variant="header" component="h2">
            {t('users:higher_plan_only.title')}
          </StyledTitle>
          <StyledText variant="body2">
            {t('users:higher_plan_only.description')}
          </StyledText>
        </StyledDescription>
        <ButtonsContainer direction="vertical">
          <SubscriptionButton />
          <Button
            variant="contained"
            color="secondary"
            onClick={() => closeModal()}
          >
            {t('shared:close')}
          </Button>
        </ButtonsContainer>
      </Modal.Content>
    </Modal>
  );
};
